export * from './revenuecat';

export function isNonNullable<T>(value: T | null | undefined): value is T {
  return value != null;
}

export function isTruthy<T>(value: T | false | '' | 0 | null | undefined): value is T {
  return Boolean(value);
}
